
const backendUrl = process.env.REACT_APP_BACKEND_URL;

module.exports = backendUrl